import React, { useEffect, useMemo, useState } from "react";
import { toggleFavoriteGame } from "../../api/putApi";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { notice } from "../../redux/action/action";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";
import { getFavoriteGameList } from "../../api/getApi";
import { storeFavoriteGameList } from "../../redux/action/game/gameAction";
import { AbsoluteCenter, Box, Icon, useColorModeValue } from "@chakra-ui/react";
import useCheckLogin from "../../hook/useCheckLogin";
import { BsFillSuitHeartFill } from "react-icons/bs";

const ToggleFavorite = ({ fontSize, customGameUid, boxClassName }) => {
  const { t } = useTranslation();
  const i18n_common = (key) => t(`common.${key}`);
  const dispatch = useDispatch();

  const { isLogin } = useCheckLogin();

  const gameConfig = useSelector((state) => state.isGameConfig);
  const isHandleAllGame = useSelector((state) => state.isHandleAllGame);
  const { favoriteGameList } = isHandleAllGame;

  const { gameUid } = gameConfig;

  const findIsFavorite = useMemo(() => {
    if (customGameUid) {
      return favoriteGameList?.some((item) => item.gameUid === customGameUid);
    }
    return favoriteGameList?.some((item) => item.gameUid === gameUid);
  }, [gameUid, favoriteGameList, customGameUid]);

  const [isClicking, setIsClicking] = useState(false);
  const [favorite, setFavorite] = useState(findIsFavorite);

  const navigate = useNavigate();

  useEffect(() => {
    if (gameConfig) {
      setFavorite(findIsFavorite);
    }
  }, [gameConfig, findIsFavorite]);

  const handleToggleFavorite = (toggleCode) => {
    if (!isLogin) {
      navigate("signin");
      return;
    }
    setIsClicking(true);
    setFavorite(!favorite);
    toggleFavoriteGame({
      gameUid: customGameUid || gameUid,
      params: {
        status: toggleCode,
      },
    })
      .then((data) => {
        getFavoriteGameList().then((data) => {
          dispatch(storeFavoriteGameList(data.userFavoriteGame));
        });
      })
      .catch((err) => {})
      .finally(() => {
        setIsClicking(false);
      });
  };

  return (
    <Box
      position="absolute"
      zIndex={3}
      top={"1%"}
      right={"1%"}
      bgImage={
        favorite
          ? "linear(to-b,#EF4040,#AC1414)"
          : "linear(to-b,#ECECEC,#C7C7C7)"
      }
      w="20%"
      maxW="32px"
      aspectRatio={"1 / 1"}
      maxH="32px"
      borderRadius="full"
      display="flex"
      alignItems="center"
      justifyContent="center"
      overflow={"hidden"}
      border={favorite ? "2px solid" : "2px solid"}
      shadow="md"
      borderColor={favorite ? "#b12a2a" : "#C8C8C8"}
      {...boxClassName}
    >
      {favorite ? (
        <Icon
          onClick={() => {
            if (isClicking) {
              return;
            }
            handleToggleFavorite(0);
          }}
          cursor="pointer"
          as={BsFillSuitHeartFill}
          w="65%"
          h="65%"
          mt="2%"
          color={"#980000"}
          position="relative"
          zIndex={1}
        />
      ) : (
        <Icon
          onClick={() => {
            if (isClicking) {
              return;
            }
            handleToggleFavorite(1);
          }}
          cursor="pointer"
          as={BsFillSuitHeartFill}
          w="65%"
          h="65%"
          mt="2%"
          color={"#afafaf"}
          position="relative"
          zIndex={1}
        />
      )}
    </Box>
  );
};

export default ToggleFavorite;
